import { axiosPrivate } from "../../api/axios";

const getOrder = async (orderId) => {
  const response = await axiosPrivate.get(`/orders/${orderId}`);
  return response.data;
};

const createOrder = async (orderData) => {
  const fromCart = localStorage.getItem("fromCart") === "true";
  if (fromCart) {
    orderData.fromCart = true;

    localStorage.removeItem("fromCart");
  } else {
    orderData.fromCart = false;
  }

  if (!orderData.source) {
    orderData.source = fromCart ? "cart" : "direct";
  }

  const response = await axiosPrivate.post(`/orders`, orderData);
  return response.data;
};

const cancelOrder = async (data) => {
  const { orderId, reason, note } = data;
  const response = await axiosPrivate.post(`/orders/user/cancel/${orderId}`, {
    reason,
    note,
  });
  return response.data;
};

const getUserOrders = async () => {
  const response = await axiosPrivate.get(`/orders/user/my-orders`);
  return response.data;
};

const checkOrderReactivation = async (orderId) => {
  const response = await axiosPrivate.get(
    `/orders/user/check-reactivation/${orderId}`,
  );
  return response.data;
};

const reactivateOrder = async (data) => {
  const { orderId, note, skipCoupon } = data;
  const response = await axiosPrivate.post(
    `/orders/user/reactivate/${orderId}`,
    { note, skipCoupon },
  );
  return response.data;
};

const placeOrderAgainDelivered = async (orderId) => {
  const response = await axiosPrivate.post(
    `/orders/user/order-again/${orderId}`,
  );
  return response.data;
};

const deleteOrder = async (orderId) => {
  const response = await axiosPrivate.delete(`/orders/user/delete/${orderId}`);
  return response.data;
};

const updateProductQuantity = async (data) => {
  const response = await axiosPrivate.post(
    `/orders/user/update-quantity`,
    data,
  );
  return response.data;
};

const deleteOrderProduct = async (data) => {
  const response = await axiosPrivate.post(`/orders/user/delete-product`, data);
  return response.data;
};

const updateOrderNote = async ({ orderId, customerNotes }) => {
  const response = await axiosPrivate.patch(`/orders/${orderId}/note`, {
    customerNotes,
  });
  return response.data;
};

const orderService = {
  createOrder,
  getOrder,
  getUserOrders,
  cancelOrder,
  checkOrderReactivation,
  reactivateOrder,
  placeOrderAgainDelivered,
  deleteOrder,
  updateProductQuantity,
  deleteOrderProduct,
  updateOrderNote,
};

export default orderService;
